import React from "react";
import { useCallback, useState } from "react";
import PropTypes from "prop-types";

import { Button, Popup } from "semantic-ui-react";

export const CopyDataButton = ({ metadata }) => {
  const [popupContent, setPopupContent] = useState("Copy");
  const [popupOpen, setPopupOpen] = useState(false);

  const onCopyClick = useCallback(async (metadata) => {
    await navigator.clipboard.writeText(JSON.stringify(metadata));
    setPopupContent("Copied!");
    setTimeout(() => setPopupContent("Copy"), 1000);
  }, []);

  return (
    <Popup
      open={popupOpen}
      content={popupContent}
      trigger={
        <Button
          onMouseLeave={() => setPopupOpen(false)}
          onMouseEnter={() => setPopupOpen(true)}
          size={"tiny"}
          icon="copy outline"
          onClick={async () => await onCopyClick(metadata)}
        />
      }
    />
  );
};

CopyDataButton.propTypes = {
  metadata: PropTypes.object,
};
